/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForPrometheus extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForPrometheus");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForPrometheus.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForPrometheus>): ServiceAccountNativeDetailsForPrometheus {
        let obj = Object.assign(new ServiceAccountNativeDetailsForPrometheus(), model);
        ServiceAccountNativeDetailsForPrometheus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForPrometheus>): ServiceAccountNativeDetailsForPrometheus {
        if (!model) return null;
        return ServiceAccountNativeDetailsForPrometheus.newInstance(<ServiceAccountNativeDetailsForPrometheus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForPrometheus) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForPrometheus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForPrometheus): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForPrometheus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
